module.exports = __webpack_public_path__ + "media/images/placeholders/screenloop-novideo-placeholder-d7c8f42be0740fa5abebe695a147c170.svg";